import React from 'react';

import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { Box, Paper, Typography } from '@mui/material';

import { formatJsonDate } from './csDashboardUtils';
import { CS_FEATURE_MAP } from './features/registry';
import type { ChartDataPoint } from './types';

type Props = {
  chartData: ChartDataPoint[];
  selectedFeatureIds: string[];
  title: string;
};

export default function CsDashboardChart({ chartData, selectedFeatureIds, title }: Props) {
  return (
    <Box mt={4}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Box mt={2}>
          <ResponsiveContainer width="100%" height={400}>
            <LineChart data={chartData} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tickFormatter={formatJsonDate} />
              <YAxis allowDecimals={false} />
              <Tooltip labelFormatter={formatJsonDate} />
              <Legend />
              {selectedFeatureIds.map((id) => {
                const feature = CS_FEATURE_MAP[id];
                return feature ? (
                  <Line
                    key={id}
                    type="monotone"
                    dataKey={id}
                    name={feature.label}
                    stroke={feature.color}
                    strokeWidth={2}
                  />
                ) : null;
              })}
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </Paper>
    </Box>
  );
}
